(function () {
  'use strict';

  function init(root) {
    var SCROLL_BUFFER = 16;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    var tabs = root.querySelectorAll('[data-kl-ii-tab]');
    var targets = [];
    tabs.forEach(function (t) {
      var el = document.getElementById(t.getAttribute('data-target'));
      if (el) targets.push({ tab: t, el: el });
    });

    function getHeaderBottom() {
      var header = document.querySelector('.shopify-section--header, .shopify-section-header, #shopify-section-header, header.site-header');
      if (!header) return 0;
      var rect = header.getBoundingClientRect();
      return Math.max(0, rect.bottom);
    }

    var nav = root.querySelector('[data-kl-ii-tabs]');
    var spacer = root.querySelector('[data-kl-ii-spacer]');
    var tabsInner = nav ? nav.querySelector('.kl-ii-tabs-inner') : null;
    var lastCenteredTab = null;

    function centerTab(tab) {
      if (!tab || !tabsInner || tab === lastCenteredTab) return;
      var target = tab.offsetLeft + tab.offsetWidth / 2 - tabsInner.clientWidth / 2;
      var max = tabsInner.scrollWidth - tabsInner.clientWidth;
      if (max <= 0) return;
      if (target < 0) target = 0;
      if (target > max) target = max;
      tabsInner.scrollTo({ left: target, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      lastCenteredTab = tab;
    }

    function syncSticky() {
      if (!nav || !spacer) return;
      var headerBottom = getHeaderBottom();
      var triggerTop = spacer.classList.contains('is-active')
        ? spacer.getBoundingClientRect().top
        : nav.getBoundingClientRect().top;

      if (triggerTop <= headerBottom) {
        if (!nav.classList.contains('is-fixed')) {
          spacer.style.height = nav.offsetHeight + 'px';
          spacer.classList.add('is-active');
          nav.classList.add('is-fixed');
        }
        nav.style.top = headerBottom + 'px';
      } else {
        if (nav.classList.contains('is-fixed')) {
          nav.classList.remove('is-fixed');
          nav.style.top = '';
          spacer.classList.remove('is-active');
          spacer.style.height = '';
        }
      }

      var stickyTop = headerBottom + (nav.offsetHeight || 0) + 24;
      root.style.setProperty('--kl-ii-sticky-top', stickyTop + 'px');

      if (targets.length) {
        var navHeight = nav.offsetHeight || 0;
        var triggerLine = headerBottom + navHeight + SCROLL_BUFFER * 2;
        var active = targets[0];
        for (var i = targets.length - 1; i >= 0; i--) {
          if (targets[i].el.getBoundingClientRect().top <= triggerLine) {
            active = targets[i];
            break;
          }
        }
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        if (active) {
          active.tab.classList.add('is-active');
          centerTab(active.tab);
        }
      }
    }

    window.addEventListener('scroll', syncSticky, { passive: true });
    window.addEventListener('resize', syncSticky, { passive: true });
    syncSticky();

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(tab.getAttribute('data-target'));
        if (!target) return;
        var offset = getHeaderBottom() + (nav ? nav.offsetHeight : 0) + SCROLL_BUFFER;
        var y = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: y, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        centerTab(tab);
      });
    });

    /* Facts accordion */
    root.querySelectorAll('[data-kl-ii-facts]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-kl-ii-facts-toggle]');
      if (!btn) return;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* Show more */
    root.querySelectorAll('[data-kl-ii-list]').forEach(function (list) {
      var threshold = parseInt(list.getAttribute('data-collapse'), 10) || 5;
      var rows = list.querySelectorAll('.kl-ii-row');
      if (rows.length <= threshold) return;

      rows.forEach(function (row, i) {
        if (i >= threshold) row.classList.add('is-hidden');
      });

      var panel = list.closest('.kl-ii-panel');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kl-ii-show-more';
      btn.setAttribute('aria-expanded', 'false');
      var labelShow = 'Show All ' + rows.length + ' Ingredients';
      var labelHide = 'Show Less';
      btn.innerHTML = '<span>' + labelShow + '</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
      list.appendChild(btn);

      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        rows.forEach(function (row, i) {
          if (i >= threshold) row.classList.toggle('is-hidden', expanded);
        });
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        btn.querySelector('span').textContent = expanded ? labelShow : labelHide;
        if (expanded && panel) {
          var offset = getHeaderBottom() + (nav ? nav.offsetHeight : 0) + SCROLL_BUFFER;
          var y = panel.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: y, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-kl-ii-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
